module.exports = __webpack_public_path__ + "img/suspended1.e955efe0.svg";